import React, { FC, useMemo } from 'react';
import { Descriptions, DescriptionsRow } from 'common/components';
import { IGood } from 'entities/Goods/Goods.models';

interface IComponentProps {
  good: IGood | null;
}

export const GoodProperties: FC<IComponentProps> = ({ good }) => {
  const properties = useMemo(() => {
    const properties = good?.properties ?? [];

    return properties.filter((item) => item.propertyName !== 'Бренд');
  }, [good]);

  return (
    <div className=" flex align-start gap-11">
      <div className="w-50">
        <div className="mb-6 ff-medium fs-m">Технические характеристики</div>

        <Descriptions>
          {properties.map((item) => {
            let value = item.value;

            if (item.unitOfMeasurement) {
              value += ` ${item.unitOfMeasurement}`;
            }

            return <DescriptionsRow key={item.propertyId} label={item.propertyName} value={value} />;
          })}
        </Descriptions>
      </div>

      <div className="w-50">
        <div className="mb-6 ff-medium fs-m">Информация о производителе</div>

        <Descriptions>
          {good?.brand && <DescriptionsRow label="Бренд" value={good.brand} />}

          {good?.countryOfOrigin && <DescriptionsRow label="Страна производства" value={good.countryOfOrigin} />}
        </Descriptions>
      </div>
    </div>
  );
};
